import {Types} from './actions';
import initialState from './initialState';
import ReducerBuilder from 'classes/ReducerBuilder';

export default ReducerBuilder.make(initialState)
  .forType(Types.SUBMIT_COPY_PRIZE)
  .reduce((state, action) => {
    state.copyPrizeFormSubmitted = true;
  })
  .forType(Types.COPY_PRIZE_COMPLETE)
  .reduce((state, action) => {
    // reset booleans
    state.copyPrizeFormSubmitted = false;
    state.copyingPrize = false;

    state.createdPrizeId = action.prizeId;
    state.copyPrizeId = null;

    state.error = null;
  })
  .forType(Types.START_COPY_PRIZE)
  .reduce((state, action) => {
    state.copyingPrize = true;
    state.createdPrizeId = null;
    state.copyPrizeId = action.copyPrizeId;
  })
  .forType(Types.END_COPY_PRIZE)
  .reduce((state, action) => {
    state.copyingPrize = false;
    state.createdPrizeId = null;
    state.copyPrizeId = null;
    state.error = null;
  })
  .forType(Types.COPY_PRIZE_ERROR)
  .reduce((state, action) => {
    state.error = action.error;
  })
  .build();



// WEBPACK FOOTER //
// ./public/pages/PrizeCopy/reducer.js